import React from 'react'

// HardCodeImageData
const INIT_IMAGES = [
    {
      id: 1,
      filePath: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&h=600&fit=crop',
      actualFileName: 'Design Mockup - Landing Page',
      statusText:'Puase',
      annotations: []
    },
    {
      id: 2,
      filePath: 'https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=800&h=600&fit=crop',
      actualFileName: 'Web Development Interface',
      statusText:'Puase',
      annotations: []
    },
    {
      id: 3,
      filePath: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&h=600&fit=crop',
      actualFileName: 'Analytics Dashboard',
      statusText:'Puase',
      annotations: []
    }
  ];

  const COLORS = ['#ff4444','#44ff44','#4444ff','#ffff44','#ff44ff','#44ffff','#ff8844','#8844ff'];

  const TOOLS = [
    {type: 'circle', label: 'Circle'},
    {type: 'rectangle', label: 'Rectangle'},
    {type: 'freeform', label: 'Freeform'}
  ];
  
  function uuid() {
    return Math.random().toString(36).slice(2,11) + "-" + Date.now();
  }
  
  const CURRENT_USER = {id: 1, name: 'Alex Designer'};
  


export  {
INIT_IMAGES,
CURRENT_USER,
uuid,
TOOLS,
COLORS,

}
